import NewsletterTwentyOneContainer from "./containers/NewsletterTwentyOneContainer";
export default NewsletterTwentyOneContainer;
